module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_27-264e43f6ee8e49b21a62179614474af0.png";